<template>
  <a
    :href="url"
    target="_blank"
    class="bg-white rounded-lg border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow group cursor-pointer"
  >
    <!-- Thumbnail -->
    <div class="relative aspect-video overflow-hidden bg-gray-900">
      <img
        :src="thumbnail"
        :alt="title"
        class="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-300"
      />
      <div class="absolute inset-0 flex items-center justify-center">
        <div
          class="w-14 h-14 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center group-hover:bg-white group-hover:scale-110 transition-all"
        >
          <Play :size="24" class="text-brand ml-1" fill="currentColor" />
        </div>
      </div>
      <div
        v-if="duration"
        class="absolute bottom-2 right-2 bg-black/80 text-white text-xs px-2 py-1 rounded flex items-center gap-1"
      >
        <Clock :size="12" />
        <span class="sr-only">{{ t('videoCard.duration') }}</span>
        {{ duration }}
      </div>
    </div>

    <!-- Content -->
    <div class="p-4">
      <h3 class="font-semibold text-gray-900 line-clamp-2 mb-2 leading-snug">
        {{ title }}
      </h3>
      <p class="text-sm text-gray-500">{{ d(date, 'short') }}</p>
    </div>
  </a>
</template>

<script setup lang="ts">
import { Play, Clock } from 'lucide-vue-next';
import { useI18n } from 'vue-i18n';

const { d } = useI18n()

defineProps<{
  url: string
  thumbnail: string;
  title: string;
  duration?: string;
  date: Date;
}>();
</script>
